import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "theme-ui"

// markup
const IndexPage = () => {
    const data = useStaticQuery(query)

    const { company } = data

    return (
        <>
            <p>
                For more information, or to talk with the Head of the Early
                Intervention Program, please do not hesitate to contact us by
                phone{" "}
                <Link
                    href={`tel:${company.tel}`}
                    rel="noreferrer"
                    target="_blank"
                >
                    {company.tel}
                </Link>{" "}
                or email at{" "}
                <Link
                    href={`mailto:${company.email}`}
                    rel="noreferrer"
                    target="_blank"
                >
                    {company.email}
                </Link>
                .
            </p>
        </>
    )
}

export default IndexPage

const query = graphql`
    query {
        company: strapiCompany(shortname: { eq: "EIP" }) {
            email
            address
            name
            tel
            whatsapp
        }
    }
`
